import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import { cancelDeleteRequest } from '../../../../../ducks/user/mydata';
import Button from '../../../components/Button';
import styles from './data-card.scss';

const propTypes = {
  btnFunc: PropTypes.func,
  btnText: PropTypes.element,
  dispatch: PropTypes.func.isRequired,
  mid: PropTypes.element,
  request: PropTypes.shape({
    state: PropTypes.string,
    type: PropTypes.string,
    created_at: PropTypes.string,
  }),
  saving: PropTypes.bool,
};

class DataCard extends React.Component {
  cancelDelete = () => {
    const { dispatch } = this.props;
    dispatch(cancelDeleteRequest());
  }

  render() {
    const {
      request,
      mid,
      btnText,
      btnFunc,
      saving,
    } = this.props;

    const statuses = {
      export: {
        new: <FormattedMessage
          defaultMessage="We've sent an email to you to confirm your data export. Please check your inbox."
          id="datacard.statuses.export.new"
        />,
        in_progress: <FormattedMessage
          id="datacard.statuses.export.in_progress"
          defaultMessage="Your data export is in progress. You will soon receive an email containing a link to download your data."
        />,
        closed: <FormattedMessage
          id="datacard.statuses.export.closed"
          defaultMessage="You have canceled the data export."
        />,
        done: <FormattedMessage
          id="datacard.statuses.export.done"
          defaultMessage="Your data export is done! Please check your inbox for an email containing a link to download your data."
        />,
      },
      delete: {
        new: <FormattedMessage
          id="datacard.statuses.delete.new"
          defaultMessage="We've sent an email to you to confirm your data removal. Please check your inbox."
        />,
        in_progress: <FormattedMessage
          id="datacard.statuses.delete.in_progress"
          defaultMessage="Your data is scheduled to be deleted within the coming 24 hours. To cancel the removal, click here: {link}."
          values={{
            link: <Button onClick={this.cancelDelete} role="button" tabIndex={0}>Abort</Button>,
          }}
        />,
        closed: <FormattedMessage
          id="datacard.statuses.delete.closed"
          defaultMessage="You have canceled the data removal."
        />,
        done: <FormattedMessage
          id="datacard.statuses.delete.done"
          defaultMessage="Your data removal is done! Please check your inbox for an email with details. You probably shoudln't see this, but you are. Please contact us at support@dreamhack.com so we can fix this."
        />,
      },
    };

    return (
      <div className={styles.dataCard}>
        { mid }
        <Button
          onClick={btnFunc}
          disabled={saving || (request && (request.state === 'new' || request.state === 'in_progress'))}
        >
          {btnText}
        </Button>
        { request
          && (
          <div className={styles.status}>
            <p>
              <strong>
                <FormattedMessage id="datacard.request_status" defaultMessage="Request status:" />
              </strong>
              {' '}
              {statuses[request.type][request.state]}
            </p>
            <p>
              <strong>
                <FormattedMessage id="datacard.request_initiated" defaultMessage="Request initiated:" />
              </strong>
              {' '}
              { moment(`${request.created_at}+00`).format('Do MMMM HH:mm:ss') }
            </p>
          </div>
          )}
      </div>
    );
  }
}

DataCard.propTypes = propTypes;

export default injectIntl(connect()(DataCard));
